export default {
  caixaPasta: {
    value: null,
    maxlength: '50',
    required: false,
    state: null
  },
  nome: {
    value: null,
    maxlength: '70',
    required: true,
    state: null
  },
  justificativa: {
    value: null,
    maxlength: '70',
    required: false,
    state: null
  },
  arquivo: {
    value: null,
    required: true,
    state: null
  },
  dataEnvio: {
    value: null,
    maxlength: '10',
    required: true,
    state: null
  },
  validade: {
    value: null,
    maxlength: '10',
    required: false,
    state: null
  },
  status: {
    value: null,
    options: [
      { text: 'Pendente', value: 1 },
      { text: 'Finalizado', value: 2 },
      { text: 'Reprovado', value: 3 }
    ],
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/archiveDocumentsManagement/components/AddDocument/AddDocumentForm.js